import 'animate.css/animate.min.css';
import { useEffect } from 'react'
import moment from 'moment';
import { Suspense, lazy } from 'react';
import { Route, Switch } from 'react-router-dom';
import LoadingWrapper from 'src/components/Loading/LoadingWrapper';
import 'moment/locale/es';
import { addLocale, locale } from 'primereact/api';
import { Provider } from 'react-redux';
import { ToastProvider } from 'react-toast-notifications';
import Rutas from './Routes';
import store from './store';
import validator from 'validator';
// import { createGlobalStyle } from "styled-components";
import { desencriptarTramaAES } from 'src/utils/Encriptar/Encriptar'
import { themeDefault } from 'src/theme/Theme'


// import original module declaration
import 'styled-components';

// and extend it
declare module 'styled-components' {
  export interface DefaultTheme {
    colors: {
      primary: string;
      letraPrimaria1: string;
      letraPrimaria2: string;
      primarySemiDark: string;
      primaryLight: string;
      primaryDark: string;
      primaryDark2: string;
      secondary: string;
      secondaryLight: string;
      secondaryDark: string;
      ternario: string;
      letraTernario1: string;
      letraTernario2: string;
      colorStepper: string;
      bg1: string;
      textColorButton: string;
      labelInputColor: string;
      textColor1: string;
      textColor2: string;
      textColor3: string;
      textError: string;
      success: string;
      labelLanding: string;
      letraSegundaria1: string;
      letraSegundaria2: string;
    };
  }
}


// export type MyTheme = typeof themeDefault

// createGlobalStyle<MyTheme>`
// *, 
// body {
//   font-size: 14px;
//   }
// `



// const InitialConfig = () => {
addLocale('es', {
  firstDayOfWeek: 1,
  dayNames: ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'],
  dayNamesShort: ['dom', 'lun', 'mar', 'mié', 'jue', 'vie', 'sáb'],
  dayNamesMin: ['D', 'L', 'M', 'X', 'J', 'V', 'S'],
  monthNames: [
    'Enero',
    'Febrero',
    'Marzo',
    'Abril',
    'Mayo',
    'Junio',
    'Julio',
    'Agosto',
    'Septiembre',
    'Octubre',
    'Noviembre',
    'Diciembre',
  ],
  monthNamesShort: [
    'Ene',
    'Feb',
    'Nar',
    'Abr',
    'May',
    'Jun',
    'Jul',
    'Ago',
    'Sep',
    'Oct',
    'Nov',
    'Dic',
  ],
  today: 'Hoy',
  clear: 'Limpiar',
});
locale('es');
moment.locale('es');
// };

// const LayoutRouteTheme = ({ component: Component, ...rest }) => <Route component={() => <Theme><Component /></Theme>} {...rest} />
const App = () => {

  useEffect(() => {
    // init()
  }, [])

  const init = async () => {
    const myHeaders = new Headers();
    myHeaders.append('Content-Type', 'application/json');
    const requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: JSON.stringify({
        empCodigo: "ecuaprimas",
        plataforma: "WEB",
        cliIdentificacion: "1002988432"
      }),
    };
    try {
      const data = await fetch('http://nuvem-insurancepruebas74-dev.us-east-1.elasticbeanstalk.com/frontend/web/index.php?r=servicios/consultar-datos-socio', requestOptions).then((response) => response.json());
      const Data = (validator.isBase64(data.Data) && JSON.parse(window.atob(data.Data))) ?? { data: '', iv: '', key: '' };
      console.log("AppData", Data)
      if (Data.iv && Data.data && Data.key) {
        let dato = await desencriptarTramaAES(Data.data, Data.key, Data.iv);
        console.log("AppData2", dato)
        dato = JSON.parse(dato);
        console.log({ res: dato })
      }

      // }
      // ,
      // "browser": {
      //   "crypto": false

      console.log({ error: 'No se obtuvo una respuesta', data })
    } catch (err) {
      console.log({ error: 'Error al tratar de obtener resultado', mensaje: err })
    }
  }

  return (
    <Provider store={store}>
      <ToastProvider autoDismiss autoDismissTimeout={10000} placement="top-right">
        <Rutas />
      </ToastProvider>
    </Provider>
  );
};

export default App;
